module.exports = "/_next/static/images/e5453af0c9aa4951e3c714417a11aa5f-payment_modal.png.webp";